import { render, staticRenderFns } from "./CircuitMapImageSugo.vue?vue&type=template&id=5881a639"
import script from "./CircuitMapImageSugo.vue?vue&type=script&lang=ts"
export * from "./CircuitMapImageSugo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports